import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardView from '../views/DashboardView'
import ConfiguracionView from '../views/ConfiguracionView'
import GruposView from '../views/GruposView'
import ProgramacionesView from '../views/ProgramacionesView'
import AnalisisView from '../views/AnalisisView'
import InformesView from '../views/InformesView'
// import AlarmasView from '../views/AlarmasView'
import LoginView from '../views/LoginView'
import ContadoresView from '../views/ContadoresView'
import UsuarioView from '../views/UsuarioView'
import CrearPasswordView from '../views/CrearPasswordView'
import OlvidePasswordView from '../views/OlvidePasswordView'

Vue.use(VueRouter)

const router =  new VueRouter({
    mode:'hash',
    routes:[
        {
            path:'/Login',
            name:'Login',
            component:LoginView
        },
        // Enlace del correo (invitación de ECOS Manager o recuperación) para crear la contraseña
        {
            path:'/reset-password/:token',
            name:'CrearPassword',
            component:CrearPasswordView
        },
        {
            path:'/olvide-password',
            name:'OlvidePassword',
            component:OlvidePasswordView
        },
        {
            path:'/Panel',
            name:'Panel',
            component:DashboardView
        },
        {
            path:'/Contadores',
            name:'Contadores',
            component:ContadoresView
        },
        {
            path:'/Grupos',
            name:'Grupos',
            component:GruposView
        },
        {
            path:'/Programaciones',
            name:'Programaciones',
            component:ProgramacionesView
        },
        {
            path:'/Analisis',
            name:'Analisis',
            component:AnalisisView
        },
        {
            path:'/Informes',
            name:'Informes',
            component:InformesView
        },
        // {
        //     path:'/Alarmas',
        //     name:'Alarmas',
        //     component:AlarmasView
        // },
        {
            path:'/',
            redirect:'/Login'
        },
        {
            path:'/Usuario',
            name: 'Usuario',
            component:UsuarioView
        },
                {
            path:'/Configuracion',
            name:'Configuracion',
            component:ConfiguracionView
        },
    ]
})

export default router